import React, { useState } from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Heading, Wrapper, Paragraph, Head } from '@/shared/styled'
import LeaderIcon from '@/components/svg/why/LeaderIcon'
import LearnIcon from '@/components/svg/why/LearnIcon'
import PaidIcon from '@/components/svg/why/PaidIcon'
import NetworkIcon from '@/components/svg/why/NetworkIcon'
import { withPrefix } from 'gatsby'

const perks = [
  {
    Icon: LeaderIcon,
    Component: () =>
      "Collect an outline vision with the team leader's mentorship for you career roadmap.",
  },
  {
    Icon: LearnIcon,
    Component: () =>
      'Live your value and foster your skills through the code of craftsmanship',
  },
  {
    Icon: PaidIcon,
    Component: () => (
      <>
        You get paid for your experience with an allowance worths
        <br />
        <b>$300/month.</b>
      </>
    ),
  },
  {
    Icon: NetworkIcon,
    Component: () => 'Expand your network and boost your competencies.',
  },
]

const IconWrapper = styled.div`
  height: 64px;
`

const PerkBlock = styled.div`
  background-color: ${props => props.theme.greyLighter};
  border-radius: 20px;
  ${tw`px-12 py-8 text-center`};
`

const TabButton = styled.button`
  ${tw`sm:mx-8 mx-3 inline-block`};
  background: transparent;
  border-bottom: 3px solid transparent;
  padding-bottom: 10px;
  color: ${props => props.theme.black};
  font-size: 20px;
  transition: all 0.1s ease;
  &:disabled {
    color: ${props => props.theme.primary};
    pointer-events: none;
    opacity: 1;
    border-bottom-color: ${props => props.theme.primary};
  }
`

const TabButtonContainer = styled.div`
  text-align: center;
  margin-top: 15px;
`

const TabContainer = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  ${tw`items-center flex-wrap sm:flex-row flex-col-reverse`}
`

const TabHeading = styled.h5`
  font-size: 20px;
  font-weight: 600;
`

const TabContainerWrap = styled.div`
  max-width: 460px;
`

const List = styled.ul`
  ${tw`list-reset`};
  font-weight: 500;
  line-height: 23px;
  li {
    margin-top: 9px;
    ${tw`flex items-center`};
    &:before {
      content: '';
      width: 5px;
      height: 5px;
      background-color: ${props => props.theme.black};
      border-radius: 9999px;
      display: block;
      margin-right: 16px;
    }
  }
`

const WhySection = () => {
  const [tab, setTab] = useState(0)

  return (
    <section className="mb-24" id="why">
      <Wrapper>
        <Head className="mb-18">
          <Heading>Why Dwarves</Heading>
          <Paragraph>
            We strive to create a generation of new tech enthusiasts who possess
            the same DNA with us, to generate a solid groundwork and go along
            with the company’s triumph.
          </Paragraph>
        </Head>

        <div className="flex flex-wrap -mx-5">
          {perks.map(({ Icon, Component }, index) => (
            <div
              className="lg:w-1/4 sm:w-1/2 w-full px-5 flex mb-10"
              key={index}
            >
              <PerkBlock>
                <IconWrapper>
                  <Icon />
                </IconWrapper>
                <Paragraph className="mt-8">
                  <Component />
                </Paragraph>
              </PerkBlock>
            </div>
          ))}
        </div>

        <div className="pt-10 pb-20">
          <TabButtonContainer>
            <TabButton disabled={tab === 0} onClick={() => setTab(0)}>
              Who we are
            </TabButton>
            <TabButton disabled={tab === 1} onClick={() => setTab(1)}>
              What we have
            </TabButton>
          </TabButtonContainer>
        </div>

        <div className="-mx-5">
          <TabContainer show={tab === 0}>
            <div className="px-5 sm:w-1/2 w-full">
              <TabContainerWrap>
                <TabHeading className="mb-5">
                  We are Dwarves Foundation
                </TabHeading>
                <Paragraph className="mb-5">
                  An offshore software woodland that strives to become a part of
                  global startup field, by offering a technical partnership that
                  takes over from ideas and operation to maintenance and
                  world-class quality solutions.
                </Paragraph>
                <Paragraph>
                  We opt for microservice and serverless. We take Golang,
                  ReactJS, Elixir, Swift and AWS as our main voice. As a
                  co-founder of Vietnam Golang Community, our technical talents
                  take the pledge of bringing your next development step to a
                  whole new level.
                </Paragraph>
              </TabContainerWrap>
            </div>
            <div className="px-5 sm:w-1/2 w-full sm:mb-0 mb-8">
              <img
                src={withPrefix('/img/Who-we-are.png')}
                srcSet={`${withPrefix('/img/Who-we-are@2x.png')} 2x`}
                alt="who we are"
                style={{ borderRadius: '20px' }}
              />
            </div>
          </TabContainer>
          <TabContainer show={tab === 1}>
            <div className="px-5 sm:w-1/2 w-full">
              <TabContainerWrap>
                <Paragraph className="mb-5">
                  Our woodland is a sum of great technology, engineering
                  culture, and smart people. The numbers speak it for
                  themselves:
                </Paragraph>
                <List>
                  <li>5 years in the market</li>
                  <li>40 talented members</li>
                  <li>10 common team size per deployments</li>
                  <li>3 Vietnam Development Community Influenced</li>
                </List>
              </TabContainerWrap>
            </div>
            <div className="px-5 sm:w-1/2 w-full sm:mb-0 mb-8">
              <img
                src={withPrefix('/img/What-we-have.png')}
                srcSet={`${withPrefix('/img/What-we-have@2x.png')} 2x`}
                alt="what we have"
                style={{ borderRadius: '20px' }}
              />
            </div>
          </TabContainer>
        </div>
      </Wrapper>
    </section>
  )
}

export default WhySection
